module.exports = __webpack_public_path__ + "static/media/Concept_CenterPalace.17ad210e.jpg";